module.exports = __webpack_public_path__ + "static/media/keyoff.ff388d05.svg";